import React, { useState, useEffect } from 'react';
import { Tab, Tabs } from '@material-ui/core';
import { CustomTable } from './CustomTable';

export const TabbedTable = ({ tabData, tabColumns, tabDetails, tabActions, tabNames, style }) => {
    const [columns, setColumns] = useState<any[]>([]);
    const [actions, setActions] = useState<any[]>([]);
    const [selectedTab, setSelectedTab] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        handleChange(null, selectedTab);
    }, [tabData])// eslint-disable-line react-hooks/exhaustive-deps

    const handleChange = (e, tab) => {
        setColumns(tabColumns[tab]);
        setActions(tabActions[tab])
        setSelectedTab(tab)
    }

    return (
        <>
            <CustomTable
                title={
                    <Tabs style={{ backgroundColor: "white" }} value={selectedTab} onChange={handleChange}>
                        {tabNames.map((n, i) => <Tab key={i} label={n}></Tab>)}
                    </Tabs>
                }
                actions={actions}
                columns={columns}
                dataSet={tabData[selectedTab]}
                refresh={loading} setRefresh={setLoading} pageSize={15} enablePaging={true}
                districtId={null} addedQuery={null} hiddenColumns={[]} setHiddenColumns={() => { }} hiddenColumnsDisabled={true}
                tableHeight={"400px"} enableSearch={false} searchPlaceholder={null} dataEndpoint={null}
            />
        </>
    );
}